// extracted by mini-css-extract-plugin
export default {"formInputRow":"ManualEntryFormScreen_style_formInputRow__pLA40","control":"ManualEntryFormScreen_style_control__jENEa","rotate":"ManualEntryFormScreen_style_rotate__UHrQL"};